var stripe = null,
    elements = null;

function createStripe(token) {
    if(!stripe && token) {
        stripe = Stripe(token);
        elements = stripe.elements();
    }
}

export {
    stripe,
    elements,
    createStripe
};
